import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IBasePopupModel } from '../../models/popup.model';
import { BasePopupComponent } from '../base-popup/base-popup.component';

@Component({
    selector: 'app-logout-popup',
    standalone: false,
    templateUrl: './logout-popup.component.html',
    styleUrl: './logout-popup.component.scss',
})
export class LogoutPopupComponent extends BasePopupComponent {
    protected title: string = 'Sign Out?';
    protected confirmButtonLabel: string = 'Sign Out';
    protected cancelButtonLabel: string = 'Stay Logged In';

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: IBasePopupModel,
        protected override dialogRef: MatDialogRef<LogoutPopupComponent>,
    ) {
        super(data, dialogRef);
    }
}
